// src/utils/pricing.js
import api from "./base_url";

export async function fetchCartPricing(items) {
    // items: [{ product, quantity }]
    const res = await api.post("cart/pricing-preview/", { items });
    return res.data; // { status, items: [...], subtotal }
}